import { render, staticRenderFns } from "./SubNav.vue?vue&type=template&id=326a0f8b&scoped=true&"
import script from "./SubNav.vue?vue&type=script&lang=js&"
export * from "./SubNav.vue?vue&type=script&lang=js&"
import style0 from "./SubNav.vue?vue&type=style&index=0&id=326a0f8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326a0f8b",
  null
  
)

export default component.exports